import React from 'react';
import PropTypes from 'prop-types'

/**
 * NumberInput.
 *
 * Component to handle number inputs
 * with some delay to avoid frequest value change event trigger.
 *
 * @author Naveenkumar Ganesan
 */
class NumberInput extends React.Component {
    _handleOnChange = (v) => {
        this.valueChanged = true;
        this.setState({
            val: v
        });
        this._updateValWithDelay(v);
    }

    _updateValWithDelay = (v) => {
        if(this._updateTimer) {
            clearTimeout(this._updateTimer)
        }
        // Ignore invalid value update
        if(!v || isNaN(v)) {
            return;
        }
        let _val = parseFloat(v);
        if((_val + "").length !== v.length) {
            return;
        }
        this._updateTimer = setTimeout(() => {
            this._triggerOnChange(parseFloat(v))
        }, 300)
    }

    _triggerOnChange(v) {
        this.props.onChange(v);
    }

    // Fix val on blur
    _handleBlur = () => {
        // Reset to last valid value
        this.setState({
            val: this.props.value
        });
    }

    render() {
        let val = this.props.value;
        if(this.valueChanged) {
            val = this.state.val;
            this.valueChanged = false;
        }
        return <input type="text" value={val} name={this.props.name} aria-label={this.props.ariaLabel}
            onChange={e => this._handleOnChange(e.target.value)}
            onBlur={this._handleBlur} className={this.props.className}/>
    }
}

NumberInput.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.number,
    onChange: PropTypes.func
}

NumberInput.defaultProps = {
    name: 'number'
}

export default NumberInput;
